/// <amd-module name="SuiteCommerce.LookBook.LookBook.Router"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookBook.Router", ["require", "exports", "Backbone", "SuiteCommerce.LookBook.LookBook.Model", "SuiteCommerce.LookBook.LookBook.View"], function (require, exports, Backbone_1, LookBook_Model_1, LookBook_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookBookRouter = void 0;
    var LookBookRouter = /** @class */ (function (_super) {
        __extends(LookBookRouter, _super);
        function LookBookRouter(options) {
            var _this = _super.call(this, options) || this;
            _this.application = options.application;
            _this.environment = options.application.getComponent('Environment');
            return _this;
        }
        Object.defineProperty(LookBookRouter.prototype, "routes", {
            // @ts-ignore
            get: function () {
                return {
                    'lookbook/:lookb': 'lookbook',
                    'lookbook/:lookb?*': 'lookbook',
                };
            },
            enumerable: false,
            configurable: true
        });
        LookBookRouter.prototype.lookbook = function (urlComponent) {
            var _this = this;
            var model = new LookBook_Model_1.LookBookModel();
            model.fetch({
                data: {
                    urlcomponent: urlComponent,
                },
            })
                .done(function () {
                var view = new LookBook_View_1.LookBookView({
                    application: _this.application,
                    model: model,
                });
                view.showContent();
                view.reloadSlider();
                view.logShowSpecificLookBook();
            });
        };
        return LookBookRouter;
    }(Backbone_1.Router));
    exports.LookBookRouter = LookBookRouter;
});
